import { CONTRACT, ContractEventParams, useContract } from '@apeiron/contract'
import { useAccountContext } from '@apeiron/temp'
import * as R from 'ramda'
import { useCallback } from 'react'

export const useVesting = (): Hook => {
  const { call: doFetchClaimableAndClaimed } = useContract(
    CONTRACT.VESTING.GET_CLAIMABLE_AND_CLAIMED
  )

  const { call: doFetchVested } = useContract(CONTRACT.VESTING.GET_VESTED)

  const { sendWithOption: doClaim } = useContract(CONTRACT.VESTING.CLAIM)

  const { account } = useAccountContext()

  const claim = useCallback(
    async (value: string): Promise<boolean> => {
      try {
        await doClaim(
          {
            verifyEvent: ContractEventParams.Vesting
          },
          value
        )

        return true
      } catch (err) {
        return false
      }
    },
    [doClaim]
  )

  const fetchClaimableAndClaimed = useCallback(async (): Promise<string[]> => {
    const result = await doFetchClaimableAndClaimed(account.walletAddress)

    const [claimable, claimed] = R.isNotNil(result) ? result : ['0', '0']

    return [claimable, claimed]
  }, [account.walletAddress, doFetchClaimableAndClaimed])

  const fetchVested = useCallback(async (): Promise<string> => {
    const result = await doFetchVested(account.walletAddress)

    return R.isNotNil(result) ? result : '0'
  }, [account.walletAddress, doFetchVested])

  return {
    claim,
    fetchClaimableAndClaimed,
    fetchVested
  }
}

type Hook = {
  claim: (value: string) => Promise<boolean>
  fetchClaimableAndClaimed: () => Promise<string[]>
  fetchVested: () => Promise<string>
}
